import { render, staticRenderFns } from "./SelectionFieldAction.vue?vue&type=template&id=dd0ae462&scoped=true&"
import script from "./SelectionFieldAction.vue?vue&type=script&lang=ts&"
export * from "./SelectionFieldAction.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionFieldAction.vue?vue&type=style&index=0&id=dd0ae462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0ae462",
  null
  
)

export default component.exports